import React, { useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './MoodSnapshot.css';
import MoodIcon from '../MoodIcon/MoodIcon';
import { format } from 'date-fns';
import { CardMoodSnapshotContext } from '../../contexts/CardMoodSnapshotContext';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CheckinContext } from '../../contexts/CheckinContext';
import logComponent from '../../common/logComponent';

export default function MoodSnapshotContent() {
  const environmentContext = useContext(EnvironmentContext);
  const checkinContext = useContext(CheckinContext);
  const cardMoodSnapshotContext = useContext(CardMoodSnapshotContext);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [contentData, setContentData] = useState(null);
  const { hasToken } = environmentContext;

  if (logComponent('MoodSnapshotContent')) { console.debug('MoodSnapshotContent rendered'); }


  useEffect(() => {
    if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent useEffect [moodSnapshot]'); }
    setContentData(cardMoodSnapshotContext.moodSnapshot ? [ ...cardMoodSnapshotContext.moodSnapshot ] : null);
  }, [cardMoodSnapshotContext.moodSnapshot]);


  useEffect(() => {
    if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent useEffect  [environmentContext.hasToken, environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit, checkinContext.mostRecentCheckinCompletionTime]'); }
    if (!hasToken) return;

    setSelectedIndex(0);

  }, [environmentContext.hasToken, environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit, checkinContext.mostRecentCheckinCompletionTime]);


  const loadNextDate = () => {
    if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent loadNextDate'); }

    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
    }
  }

  const loadPrevDate = () => {
    if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent loadPrevDate'); }

    if (selectedIndex < contentData.length - 1) {
      setSelectedIndex(selectedIndex + 1);
    }
  }

    const getSelectedMood = () => {
      if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent getSelectedMood'); }
    

    return (contentData && contentData[selectedIndex] ? contentData[selectedIndex].mood : null);
  }

  const getSelectedDate = () => {
    if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent getSelectedDate'); }
    return (contentData && contentData[selectedIndex] ? contentData[selectedIndex].date : null);

  }

  const getSelectedDateWeekday = () => {
    if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent getSelectedDateWeekday'); }
    return getSelectedDate() ? format(getSelectedDate(), 'EEEE') : null;

  }

  const getSelectedDateFormatted = () => {
    if (logComponent('MoodSnapshotContent')) {console.debug('MoodSnapshotContent getSelectedDateFormatted'); }
    return getSelectedDate() ? format(getSelectedDate(), 'MMMM d, yyyy') : null;

  }

  return (contentData &&
    <div className="Mood-Snapshot__content">
      <div className="Mood-Snapshot__date-selection">
        <button
          aria-label="Previous Date"
          onClick={loadPrevDate}
          className={'Mood-Snapshot__date-control' + (selectedIndex === contentData.length - 1 ? ' Mood-Snapshot__date-control--disabled' : '')}
          disabled={contentData.length === 0 || selectedIndex === contentData.length - 1}>

          <FontAwesomeIcon icon="chevron-left"></FontAwesomeIcon>
        </button>
        <div className="Mood-Snapshot__selected-date">
          <p className="Mood-Snapshot__weekday">{getSelectedDateWeekday()}</p>
          <p className="Mood-Snapshot__date">{getSelectedDateFormatted()}</p>
          <div className="Mood-Snapshot__icon">
            <MoodIcon mood={Math.round(getSelectedMood())} />
          </div>
          <p className="Mood-Snapshot__mood-number">
            {
              getSelectedMood() ?
                `${getSelectedMood()} / 10` :
                'N/A'
            }
          </p>
        </div>
        <button
          aria-label="Next Date"
          onClick={loadNextDate}
          className={'Mood-Snapshot__date-control' + (selectedIndex === 0 ? ' Mood-Snapshot__date-control--disabled' : '')}
          disabled={selectedIndex === 0}>
          <FontAwesomeIcon icon="chevron-right" ></FontAwesomeIcon>
        </button>
      </div>
      <p className="Mood-Snapshot__explanation">
        Mood is recorded on a  1-10 scale.  The average is available for the previous 7 days.
      </p>
    </div> );
}